export default "__VITE_PUBLIC_ASSET__83906d0e__"